import * as React from 'react';
import { useState } from 'react';
import { ListIcon, CopyIcon, TrashIcon, NotePencilIcon } from "@phosphor-icons/react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from '@heroui/modal';
import { Button } from '@heroui/button';
export const actionsOptions = [undefined, 'awaiting', 'approved', 'rejected'];
const actionsIcons: Record<string, React.ReactNode> = {
  'Edit Event': <NotePencilIcon alt="Edit Event" aria-label="Edit Event" size={22} className='p-0 m-0 text-white/65 hover:text-brand-blue-light hover:cursor-pointer' />,
  'Duplicate Event': <CopyIcon alt="Duplicate Event" aria-label="Duplicate Event" size={22} className='p-0 m-0 text-white/65 hover:text-brand-blue-light hover:cursor-pointer' />,
  'Delete Event': <TrashIcon alt="Delete Event" aria-label="Delete Event" size={22} className='p-0 m-0 text-white/65 hover:text-brand-blue-light hover:cursor-pointer' />
};
const Actions = React.memo((props: {
  handleRowActions: (id: number, action: string) => void;
  data: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deleteModalKey, setDeleteModalKey] = useState<string | null>(null);
  const {
    handleRowActions,
    data
  } = props;
  const handleClick = (action: string) => {
    if (action === 'Delete Event') {
      setDeleteModalKey(data.displayOrder);
    } else {
      handleRowActions(data.displayOrder, action);
    }
  };
  return <div aria-label="Actions Column" className={`flex justify-center items-center pt-[3px]`} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      {deleteModalKey !== null && <Modal isOpen={deleteModalKey !== null} isDismissable={false} onClose={() => setDeleteModalKey(null)}>
          <ModalContent className='bg-gray-900 border-2 border-gray-200 rounded-lg text-white'>
            <ModalHeader className='bg-gray-800'>
              <h2>Confirm Deletion of event {data.displayOrder}</h2>
            </ModalHeader>
            <ModalBody className='bg-gray-700'>
              <p>Are you sure you want to delete this event? This action cannot be undone.</p>
            </ModalBody>
            <ModalFooter className='bg-gray-800'>
              <Button className='bg-gray-300 hover:bg-gray-300 border-gray-600 h-[30px]' onPress={() => {
            setDeleteModalKey(null);
          }}>
                Cancel
              </Button>
              <Button className='bg-red-300 hover:bg-red-300 border-red-600 h-[30px]' onPress={() => {
            handleRowActions(data.displayOrder, 'Delete Event');
            setDeleteModalKey(null);
          }}>
                Delete
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>}
      {!isOpen && <ListIcon size={22} aria-label="Show actions menu" />}
      {isOpen && <div className='flex justify-center w-[80px] h-[80px]'>
        <div aria-label="Actions" className='flex flex-col ml-[-5px]'>
          {Object.keys(actionsIcons).map(key => <div role="button" tabIndex={0} aria-label={key} key={key} onClick={() => handleClick(key)} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick(key);
          }
        }}>{actionsIcons[key]}</div>)}
        </div>
      </div>}
    </div>;
});
Actions.displayName = 'Actions';
export default Actions;